export interface MissingExam {
    student_id: number,
    student_name: string,
    class_name: string,
    subject_name: string,
    date: string,
    lessons: string,
    absence_type: string,
    written: boolean,
    missed_retakes: number,
}

export interface OpenExam {
    subject_id: number,
    subject_name: string,
    date: string,
}

export interface RetakeAssignment extends MissingExam {
    subject_id: number,
    present: boolean | null,
    open_exams: Array<OpenExam>,
}

export interface RetakeDate {
    id: number,
    start: string | null,
    end: string | null,
    topic: string | null,
    all_day: boolean,
    underway: boolean,
}

// The absent types tblfehlzeiten stores, see Fehlzeiten::getAbsentTypeAttribute().
export const ABSENCE_TYPES: Record<string, { label: string, colour: string }> = {
    F: {label: 'Unentschuldigt', colour: 'red'},
    E: {label: 'Entschuldigt', colour: 'green'},
    K: {label: 'Krank', colour: 'green'},
}

// Only an exam missed excused may be written again, see MissingExam::isExcused().
export const isExcused = (exam: MissingExam): boolean => ['E', 'K'].includes(exam.absence_type)
